// Reference-viewport controls for the page-builder Content canvas. Applies the shared
// device selection as a data-type attribute that CSS maps to a fixed canvas width.
document.addEventListener("DOMContentLoaded", function () {
  var controls = document.querySelector('[data-behaviour~="builder-device-controls"]');

  if (!controls) {
    return;
  }

  var iframe = document.getElementById("page-preview");
  // The reviews tab renders its own content-preview container into the same document,
  // so the canvas container is found from the iframe it wraps, not by a global query.
  var container = iframe && iframe.closest('[data-behaviour~="content-preview"]');

  if (!container) {
    return;
  }

  controls.addEventListener("click", function (event) {
    var button = event.target.closest(".responsive-icon");

    if (!button) {
      return;
    }

    var deviceType = button.getAttribute("data-device-type");
    Sparkle.DevicePreference.set(deviceType);
    applyDeviceType(deviceType);
    refreshResponsiveImagesAfterResize();
  });

  // A dry-run refresh replaces the iframe document, dropping the injected style.
  iframe.addEventListener("load", syncViewportScrollbar);

  applyDeviceType(Sparkle.DevicePreference.get());

  function applyDeviceType(deviceType) {
    var button = controls.querySelector('.responsive-icon[data-device-type="' + deviceType + '"]');

    if (!button) {
      deviceType = "unconstrained";
      button = controls.querySelector('.responsive-icon[data-device-type="unconstrained"]');
    }

    controls.querySelectorAll(".responsive-icon").forEach(function (icon) {
      icon.classList.remove("active");
    });
    button.classList.add("active");
    container.setAttribute("data-type", deviceType);
    syncViewportScrollbar();
  }

  function syncViewportScrollbar() {
    Sparkle.PreviewViewportScrollbar.apply(iframe.contentDocument, container.getAttribute("data-type"));
  }

  function refreshResponsiveImagesAfterResize() {
    iframe.addEventListener("transitionend", handleResizeSettled, { once: true });
  }

  function handleResizeSettled() {
    var doc = iframe.contentDocument;

    if (!doc) {
      return;
    }

    // Chromium does not re-run <picture> source selection when a parent resizes the
    // iframe (media queries update, the painted source does not). Reassigning each
    // source's media forces the re-selection; an unchanged selection stays cached.
    var nudge = function (source) {
      source.media = source.media; // eslint-disable-line no-self-assign
    };

    doc.querySelectorAll("source[media]").forEach(nudge);
    doc.querySelectorAll("sp-responsive-image").forEach(function (element) {
      element.refreshSources?.();
    });
  }
});
